import React from 'react';

const plans = {
  application:[
    // {
    //   id:'1244564745674Adds',
    //   circleBg: 'rgb(255, 205, 101)',
    //   name:'فروش اشتراک بورس ویو',
    //   description:[
    //     'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
    //     'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
    //     <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
    //   ],
    //   options : function (lang){
    //     return [
    //       {text:lang === 'fa' ? 'نسخه استاندارد 1 ماهه' : 'Pro-1Month', price: lang === 'fa' ? '250,000' : '250,000 kT', orginalPrice: lang === 'fa' ? <del>350,000</del> : <del>300,000 kT</del>},
    //       {text:lang === 'fa' ? 'نسخه استاندارد 3 ماهه' : 'Pro-3Month', price: lang === 'fa' ? '750,000' : '750,000 kT', orginalPrice: lang === 'fa' ? <del>850,000</del> : <del>800,000 kT</del>},
    //       // {text:lang === 'fa' ? 'نسخه استاندارد 6 ماهه' : 'Pro-6Month', price: lang === 'fa' ? '1,000,000' : '1,000,000 kT', orginalPrice: lang === 'fa' ? <del>1,250,000</del> : <del>1,250,000 kT</del>},
    //       // {text:lang === 'fa' ? 'نسخه استاندارد 1 ساله' : 'Pro-12Month', price: lang === 'fa' ? '2,000,000' : '2,000,000 kT', orginalPrice: lang === 'fa' ? <del>2,250,000</del> : <del>2,250,000 kT</del>},
    //     ]
    //   },
    //   header: { topHeader: {fa:'استاندارد',en:'Pro Package'}, subHeader: {fa:'',en:''} },
    //   fearures: [
    //     { show: true  ,  text: {fa:'صفحه بازار',en:'Market Overview'}},
    //     { show: false ,  text: {fa:'تاریخچه بازار',en:'Market level historical data'}},
    //     { show: true  ,  text: {fa:<div>دسترسی به اطلاعات مالی<br/>فقط شرکت های بورسی (<b>500</b> شرکت)</div>, en:<div>Access to more than <b>500</b> companie’s financial data</div>}},
    //     { show: true  ,  text: {fa:<div>تاریخچه قیمت از سال <b>1380</b></div>, en:<div>Historical price from <b>2001</b></div>}},
    //     { show: true  ,  text: {fa:<div>اطلاعات <b>اولیه</b> صنایع مختلف</div>, en:<div>Industry <b>financial</b> data</div>}},
    //     { show: true  ,  text: {fa:<div>تاریخچه صورت های مالی تا <b>5</b> دوره</div>, en:<div>Up to <b>5</b> years of financial statements</div>}},
    //     { show: true  ,  text: {fa:<div>اطلاعات <b>اولیه</b> اوراق با درآمد ثابت</div> ,en:'Comprehensive fixed income securities data'}},
    //     { show: true  ,  text: {fa:'غربالگر اولیه محدود' ,en:'Basic screener'}},
    //     { show: false ,  text: {fa:'غربالگر پیشرفته با قابلیت کد نویسی' ,en:'Professional screener with coding possibility'}},
    //     { show: true  ,  text: {fa:'خروجی به اکسل' ,en:'Export to Excel'}},
    //     { show: false ,  text: {fa:'عملکرد حقیقی و حقوقی' ,en:'Institutional and individual'}},
    //     { show: true  ,  text: {fa:'حجم دانلود 1500 مگابایت در ماه' ,en:'Download limit: 1500 Mb/Month'} },
    //   ],
    // },
    {
      id:'1009487762623Hhs',
      circleBg: 'rgb(255, 136, 124)',
      name:'فروش اشتراک بورس ویو',
      description:[
        'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
        'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
        <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
      ],
      options : function (lang){
        return [
          {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ماهه 1 کاربره' : 'Plus-1Month', price: lang === 'fa' ? '1,400,000' : '1,400,000 T', orginalPrice: lang === 'fa' ? <del>1,700,000</del> : <del>1,700,000 T</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ماهه' : 'Plus-1Month', price: lang === 'fa' ? '600,000' : '600,000 kT', orginalPrice: lang === 'fa' ? <del>750,000</del> : <del>700,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 3 ماهه' : 'Plus-3Month', price: lang === 'fa' ? '1,800,000' : '1,800,000 kT', orginalPrice: lang === 'fa' ? <del>2,400,000</del> : <del>2,300,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 6 ماهه' : 'Plus-6Month', price: lang === 'fa' ? '2,300,000' : '2,300,000 kT', orginalPrice: lang === 'fa' ? <del>2,700,000</del> : <del>2,700,000 kT</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای 3 ماهه 1 کاربره' : 'Plus-3Months-1User', price: lang === 'fa' ? '4,200,000' : '4,200,000 T', orginalPrice: lang === 'fa' ? <del>5,000,000</del> : <del>5,000,000 T</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای 3 ماهه 1 کاربره' : 'Plus-3Months-1User', price: lang === 'fa' ? '4,500,000' : '4,500,000 T', orginalPrice: lang === 'fa' ? <del>5,000,000</del> : <del>5,000,000 T</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ساله 1 کاربره' : 'Plus-12Months-1User', price: lang === 'fa' ? '10,000,000' : '10,000,000 kT', orginalPrice: lang === 'fa' ? <del>10,000,000</del> : <del>10,000,000 kT</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 2 کاربره' : 'Plus-12Months-2User', price: lang === 'fa' ? '28,000,000' : '28,000,000 T', orginalPrice: lang === 'fa' ? <del>34,000,000</del> : <del>34,000,000 T</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ساله 3 کاربره' : 'Plus-12Months-3User', price: lang === 'fa' ? '7,500,000' : '7,500,000 kT', orginalPrice: lang === 'fa' ? <del>15,000,000</del> : <del>15,000,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 4 کاربره' : 'Plus-12Months-4User', price: lang === 'fa' ? '15,000,000' : '15,000,000 kT', orginalPrice: lang === 'fa' ? <del>20,000,000</del> : <del>20,000,000 kT</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 5 کاربره' : 'Plus-12Months-5User', price: lang === 'fa' ? '55,000,000' : '55,000,000 T', orginalPrice: lang === 'fa' ? <del>80,000,000</del> : <del>80,000,000 T</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 5 کاربره' : 'Plus-12Months-5User', price: lang === 'fa' ? '55,000,000' : '55,000,000 T', orginalPrice: lang === 'fa' ? <del>80,000,000</del> : <del>80,000,000 T</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ساله 6 کاربره' : 'Plus-12Months-6User', price: lang === 'fa' ? '12,000,000' : '12,000,000 kT', orginalPrice: lang === 'fa' ? <del>30,000,000</del> : <del>30,000,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ساله 7 کاربره' : 'Plus-12Months-7User', price: lang === 'fa' ? '13,500,000' : '13,500,000 kT', orginalPrice: lang === 'fa' ? <del>35,000,000</del> : <del>35,000,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 8 کاربره' : 'Plus-12Months-8User', price: lang === 'fa' ? '20,000,000' : '20,000,000 kT', orginalPrice: lang === 'fa' ? <del>40,000,000</del> : <del>40,000,000 kT</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای 1 ساله 9 کاربره' : 'Plus-12Months-9User', price: lang === 'fa' ? '16,500,000' : '16,500,000 kT', orginalPrice: lang === 'fa' ? <del>45,000,000</del> : <del>45,000,000 kT</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 10 کاربره' : 'Plus-12Months-10User', price: lang === 'fa' ? '95,000,000' : '95,000,000 T', orginalPrice: lang === 'fa' ? <del>180,000,000</del> : <del>180,000,000 T</del>},
          {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 10 کاربره' : 'Plus-12Months-10User', price: lang === 'fa' ? '95,000,000' : '95,000,000 T', orginalPrice: lang === 'fa' ? <del>180,000,000</del> : <del>180,000,000 T</del>},
          // {text:lang === 'fa' ? 'نسخه حرفه‌ای سازمانی 1 ساله 15 کاربره' : 'Plus-12Months-15User', price: lang === 'fa' ? '30,000,000' : '30,000,000 kT', orginalPrice: lang === 'fa' ? <del>75,000,000</del> : <del>75,000,000 kT</del>},

        ]
      },
      header: { topHeader: {fa:' (Enterprise) نسخه حرفه‌ای سازمانی',en:'Plus Package'}, subHeader: {fa:'',en:''} },
      fearures: [
        { show: true  ,  text: {fa:'صفحه بازار',en:'Market Overview'}},
        { show: true  ,  text: {fa:'تاریخچه بازار',en:'Market level historical data'}},
        { show: true  ,  text: {fa:<div>دسترسی به اطلاعات مالی<br/>شرکت های بورسی و زیر مجموعه ها (<b>2000</b> شرکت)</div>, en:<div>Access to more than <b>2000</b> companie’s financial data</div>}},
        { show: true  ,  text: {fa:<div>تاریخچه قیمت از سال <b>1380</b></div>, en:<div>Historical price from <b>2001</b></div>}},
        { show: true  ,  text: {fa:<div>اطلاعات <b>مالی</b> صنایع مختلف</div>, en:<div>Industry <b>financial</b> data</div>}},
        { show: true  ,  text: {fa:<div>تاریخچه صورت های مالی تا <b>15</b> سال</div>, en:<div>Up to <b>15</b> years of financial statements</div>}},
        { show: true  ,  text: {fa:<div>اطلاعات <b>کامل</b> اوراق با درآمد ثابت</div> ,en:'Comprehensive fixed income securities data'}},
        { show: true  ,  text: {fa:'غربالگر اولیه محدود' ,en:'Basic screener'}},
        { show: true  ,  text: {fa:'غربالگر پیشرفته با قابلیت کد نویسی' ,en:'Professional screener with coding possibility'}},
        { show: true  ,  text: {fa:'خروجی به اکسل' ,en:'Export to Excel'}},
        { show: true  ,  text: {fa:'عملکرد حقیقی و حقوقی' ,en:'Institutional and individual'}},
        { show: true  ,  text: {fa:'حجم دانلود 1500 مگابایت در ماه' ,en:'Download limit: 1500 Mb/Month'} },
      ]
    }
  ],
  api:[
    {
      id:'44kk089sfgskflds',
      circleBg: 'rgb(15, 239, 193)',
      name:'فروش اشتراک وب سرویس',
      description:[
        'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
        'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
        <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
      ],
      options : function (lang){
        return [
          {text:lang === 'fa' ? 'هزینه اشتراک سالانه ' : 'Annual subscription fee', price: lang === 'fa' ? '3,000,000' : '3,000,000 kT', orginalPrice: lang === 'fa' ? <del>5,000,000</del> : <del>5,000,000 kT</del>},
        ]
      },
      header: { topHeader: {fa:'هزینه ثابت سالیانه',en:'Fixed annual cost'}, subHeader: {fa:'',en:''} },
      fearures: [
        { show: true  ,  text: {fa:<b>دسترسی ها</b>,en:<b>Access</b>}},
        { show: true  ,  text: {fa:'اطلاعات صورت‎های مالی ',en:'Financial statement information'}},
        { show: true  ,  text: {fa:'ترازنامه',en:'Balance Sheet'}},
        { show: true  ,  text: {fa:'سود و زیان',en:'Cost and Benefit'}},
        { show: true  ,  text: {fa:'تولید و فروش',en:'Production and sales'}},
        { show: true  ,  text: {fa:'اطلاعات بازار',en:'Market Information'}},
        { show: true  ,  text: {fa:'نرخ‎های رشد اقلام بنیادی',en:'Fundamental Growth Rates'}},
        { show: true  ,  text: {fa:'نرخ‎های اوراق بازار بدهی',en:'Debt market rates'}},
        { show: true  ,  text: {fa:'آیتم‎های تکنیکال',en:'Technical items'}},
        { show: true  ,  text: {fa:'آیتم‎های ریسک و بازده',en:'Risk and Return Items'}},
        { show: true  ,  text: {fa:'نسبت های مالی و ضرایب',en:'Financial ratios and coefficients'}},
      ],
    },
    {
      id:'4509576345345hhdfgs',
      circleBg: 'rgb(73, 190, 255)',
      name:'فروش اشتراک وب سرویس',
      description:[
        'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
        'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
        <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
      ],
      options : function (lang){
        return [
          {text:lang === 'fa' ? 'هزینه شارژ 50000 هیت' : '50000 hit', price: lang === 'fa' ? '1,000,000' : '1,000,000 kT', orginalPrice: lang === 'fa' ? <del>1,500,000</del> : <del>1,500,000 kT</del>},
          {text:lang === 'fa' ? 'هزینه شارژ 100000 هیت' : '100000 hit', price: lang === 'fa' ? '2,000,000' : '2,000,000 kT', orginalPrice: lang === 'fa' ? <del>3,000,000</del> : <del>3,000,000 kT</del>},
          {text:lang === 'fa' ? 'هزینه شارژ 250000 هیت' : '250000 hit', price: lang === 'fa' ? '5,000,000' : '5,000,000 kT', orginalPrice: lang === 'fa' ? <del>7,000,000</del> : <del>7,000,000 kT</del>},
        ]
      },
      header: { topHeader: {fa:'هزینه متغیر برحسب مصرف',en:'Variable cost by consumption'}, subHeader: {fa:'',en:''} },
      fearures: [
        { show: true  ,  text: {fa:<b>ویژگی ها</b>,en:<b>specifications</b>}},
        { show: true  ,  text: {fa:'مبلغ متغیر  بر حسب میزان استفاده از سرویس و با معیار Hits تعیین می گردد',en:'The fee is determined by the amount of service used and the Hits criteria'}},
        { show: true  ,  text: {fa:'هزینه مصرف هر Hit معادل 20 تومان است',en:'The cost of each hit is 20 tomans'}},
        { show: true  ,  text: {fa:'هزینه مصرف داده های بنیادی و محاسباتی 1 هیت معادل 20 تومان است',en:'The cost of using basic and computational data is 1 Hit equal to 20 Tomans'}},
        { show: true  ,  text: {fa:'هزینه مصرف داده های قیمتی و بازار  0.5 هیت معادل 10 تومان است',en:'The cost of using the pricing and market data is 0.5 Hit equal to 10 Tomans'}},
        { show: true  ,  text: {fa:'فراخوانی هر Hit تکراری تا 250 مرتبه رایگان است',en:'Calling each repetitive hit is free up to 250 times'}},
        { show: true  ,  text: {fa:'قابلیت انتخاب  یک قلم از یک صورت مالی نیز میسر است',en:'It is also possible to select a single item from a financial statement'}},
        { show: true  ,  text: {fa:'--',en:'--'}},
        { show: true  ,  text: {fa:'--',en:'--'}},
      ]
    }
  ],
  excel:[
    {
      id:'498efkkkdfgu88ege',
      circleBg: 'rgb(255, 205, 101)',
      name:'فروش اشتراک اکسل',
      options : function (lang){
        return [
          {text:lang === 'fa' ? 'هزینه اشتراک سالانه ' : 'Annual subscription fee', price: lang === 'fa' ? '3,000,000' : '3,000,000 kT', orginalPrice: lang === 'fa' ? <del>5,000,000</del> : <del>5,000,000 kT</del>},
        ]
      },
      description:[
        'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
        'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
        <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
      ],
      header: { topHeader: {fa:'هزینه ثابت سالیانه',en:'Fixed annual cost'}, subHeader: {fa:'',en:''} },
      fearures: [
        { show: true  ,  text: {fa:<b>دسترسی ها</b>,en:<b>Access</b>}},
        { show: true  ,  text: {fa:'اطلاعات صورت‎های مالی ',en:'Financial statement information'}},
        { show: true  ,  text: {fa:'ترازنامه',en:'Balance Sheet'}},
        { show: true  ,  text: {fa:'سود و زیان',en:'Cost and Benefit'}},
        { show: true  ,  text: {fa:'جریان وجوه نقد',en:'Cash Flow'}},
        { show: true  ,  text: {fa:'تولید و فروش',en:'Production and sales'}},
        { show: true  ,  text: {fa:'بهای تمام شده',en:'Cost of goods'}},
        { show: true  ,  text: {fa:'اطلاعات بازار',en:'Market Information'}},
        { show: true  ,  text: {fa:'حجم معاملات',en:'Turnover'}},
        { show: true  ,  text: {fa:'ارزش معاملات',en:'The value of transactions'}},
        { show: true  ,  text: {fa:'قیمت غیر تعدیلی',en:'Unadjusted price'}},
        { show: true  ,  text: {fa:'قیمت تعدیلی',en:'Adjustable price'}},
      ],
    },
    {
      id:'3458889jkkjdsgsd55',
      circleBg: 'rgb(255, 136, 124)',
      name:'فروش اشتراک اکسل',
      description:[
        'اعتبار این پیش فاکتور تا دو هفته پس از تاریخ صدور می باشد.',
        'افزونه های فعلی و آتی سامانه بورس ویو، در طول مدت قرارداد شامل افزایش هزینه نخواهد شد.',
        <b>پرداخت از طریق شماره حساب بانک سامان و یا ورود به سایت و خرید آنلاین امکان پذیر است</b>
      ],
      options : function (lang){
        return [
          {text:lang === 'fa' ? 'هزینه شارژ 50000 هیت' : '50000 hit', price: lang === 'fa' ? '1,000,000' : '1,000,000 kT', orginalPrice: lang === 'fa' ? <del>1,500,000</del> : <del>1,500,000 kT</del>},
          {text:lang === 'fa' ? 'هزینه شارژ 100000 هیت' : '100000 hit', price: lang === 'fa' ? '2,000,000' : '2,000,000 kT', orginalPrice: lang === 'fa' ? <del>3,000,000</del> : <del>3,000,000 kT</del>},
          {text:lang === 'fa' ? 'هزینه شارژ 250000 هیت' : '250000 hit', price: lang === 'fa' ? '5,000,000' : '5,000,000 kT', orginalPrice: lang === 'fa' ? <del>7,000,000</del> : <del>7,000,000 kT</del>},
        ]
      },
      header: { topHeader: {fa:'هزینه متغیر برحسب مصرف',en:'Variable cost by consumption'}, subHeader: {fa:'',en:''} },
      fearures: [
        { show: true  ,  text: {fa:<b>ویژگی ها</b>,en:<b>specifications</b>}},
        { show: true  ,  text: {fa:'مبلغ متغیر  بر حسب میزان استفاده از سرویس و با معیار Hits تعیین می گردد',en:'The fee is determined by the amount of service used and the Hits criteria'}},
        { show: true  ,  text: {fa:'هزینه مصرف هر Hit معادل 20 تومان است',en:'The cost of each hit is 20 tomans'}},
        { show: true  ,  text: {fa:'هزینه مصرف داده های بنیادی و محاسباتی 1 هیت معادل 20 تومان است',en:'The cost of using basic and computational data is 1 Hit equal to 20 Tomans'}},
        { show: true  ,  text: {fa:'هزینه مصرف داده های قیمتی و بازار  0.5 هیت معادل 10 تومان است',en:'The cost of using the pricing and market data is 0.5 Hit equal to 10 Tomans'}},
        { show: true  ,  text: {fa:'فراخوانی هر Hit تکراری تا 250 مرتبه رایگان است',en:'Calling each repetitive hit is free up to 250 times'}},
        { show: true  ,  text: {fa:'قابلیت انتخاب  یک قلم از یک صورت مالی نیز میسر است',en:'It is also possible to select a single item from a financial statement'}},
        { show: true  ,  text: {fa:'--',en:'--'}},
        { show: true  ,  text: {fa:'--',en:'--'}},
      ]
    }
  ],
}



export const pricingContent = {
  rightImage:{
      headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
      textContent:[
          {
              bgIconClass:'bg-yellow',
              headerIcon:<img alt='' src={require('../assets/images/policy.svg')} />,
              title:{ fa:'استفاده از بورس ویو، آسان است ', en:'It is Easy' },
              description:{
                  fa:<span>دسترسی به حساب کاربری شما، از هر مکانی امکان پذیر است.
                      برای دسترسی به سایت فقط نیاز به دسترسی به اینترنت خواهید داشت تا بورس ویو در مرورگر شما اجرا شود.</span>
                  ,
                  en:<span>You can access your account from everywhere at anytime and using any device that can run a simple web browser.</span>
              },
          },
          {
              bgIconClass:'bg-red',
              headerIcon:<img alt='' src={require('../assets/images/research.svg')} />,
              title:{ fa:'بورس ویو، دقیق است ', en:'It is Accurate' },
              description:{
                  fa:<span>تمامی اطلاعات، فرمول ها و کدهای برنامه نویسی در بورس ویو تست می شوند؛
                      به صورت اتوماتیک یا توسط متخصصین ما. به این ترتیب ما اطمینان حاصل می کنیم که تمام اطلاعات ارائه شده دقیق هستند.</span>
                  ,
                  en:<span>We test every single piece of data and every line of code that we add to BourseView to make sure it is going to be delivered in the most accurate format.
                      All the processed data is being tested by experienced financial analyst to guaranty accuracy.</span>
              },
          }
      ]
  },


  leftImage:{
      // headerImg:<img alt='' src={require('../assets/images/pic-3.jpg')}/>,
      button:{textFa:'ورود آزمایشی', textEn:'Free Trial'},
      textContent:[
          {
              title:{ fa:'کیفیت و صحت اطلاعات هدف اصلی ماست ', en:'Quality is our delivery' },
              description:{
                  fa:<span>تمامی اطلاعات و امکانات توسعه داده شده برای بورس ویو قبل از ارائه به کاربر بارها
                      تست می شوند تا اطمینان حاصل شود که کاربران از همان ابتدا تجربه مطلوبی در مواجهه با امکانات جدید خواهند داشت.<br/><br/>
                      این تست ها هم در داخل شرکت و هم توسط مشتریان منتخب ما هفته ها قبل از ارائه عمومی، انجام می گیرند.</span>
                  ,
                  en:<span>Our highly educated team of software engineers develop BourseView using Test-Driven methodology.
                      this method helps us make sure that every line of code in our platform has been tested prior to being developed.
                      In addition, our advanced development management technique, Scrum, help us work as a team to reach our predefined goals.<br/><br/><br/>
                      Our team of financial analysts tries to combine the experience of world leaders of data processing into local
                      need for data to make sure our international clients access world class information which helps them invest in Iranian companies.
                      Also they test all the pages’ outcome to ensure everything works perfectly in our desired quality.</span>
              },
          }
      ]
  },
}


export default plans;











// هزینه هر هیت معادل 20 تومان است
// • در پاسخ هر API مقدار hits گنجانده شده است
// • اطلاعات پایه برای مثال لیست قلم های مالی قابل ارایه، لیست نمادها و شاخصها دارای hits=0 و بدون هزینه است.
// • امکان گزارش گیری از مقدار استفاده در طی روز و یا بازه تاریخی از طریق API در دسترس است.



//اطلاعات صورت‎های مالی


// ترازنامه
// سود و زیان
// جریان وجوه نقد
// تولید و فروش
// بهای تمام شده



// اطلاعات بازار

// حجم معاملات
// ارزش معاملات
// قیمت غیر تعدیلی
// قیمت تعدیلی
